import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AndresB_Video2 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoAndres2 = () => {
  return (
    <>
      <ModalVideo
        id="andres-video-2"
        dataText={AndresB_Video2}
        videoSrc="https://www.youtube.com/embed/YSNVYvCMZ14?si=zx8RDb2EQ8sfJEgL"
        videoTitle="KUTER_STUDIO_AI_ANDRES_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoAndres2;
